<template>
  <div class="tax-data-edit-layers">
    <template v-for="(layer, layer_i) in layerList">
      <p-message severity="warn" v-if="!layerSpeciesList(layer).length && getRestricts(layer.composition).landType != 3"
        >Породы не добавлены в этот ярус</p-message
      >
      <div class="layer-container">
        <table class="tax-table table-common">
          <thead>
            <tr>
              <th>Ярус</th>
              <th>
                {{
                  getRestricts(layer.composition).edDer
                    ? "Состав ед.деревьев"
                    : "Состав"
                }}
              </th>
              <th>Полнота</th>
              <th>Запас сырорастущий, куб.м/га</th>
              <!-- <th>Запас сухостоя, куб.м/га</th> -->
              <!--<th>Класс возраста</th> -->
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="layer_i !== editedLayerNum">
              <td>{{ 
                      layer.layer == 11 ? 'единичные деревья': layer.layer  
                  }}
              </td>
              <td>{{ layer.composition }}</td>
              <td>{{ layer.fullness }}</td>
              <td>{{ layer.stock }}</td>
              <!-- <td>{{ layer.stock_dead }}</td> -->
              <!--<td>{{ layer.age_class }}</td> -->
              <td>
                <button
                  :disabled="
                      
                      ![1,21,22,23,4].includes(getRestricts(layer.composition).landType)
                  "
                  @click="startEditLayer(layer, layer_i)"
                >
                  Редактировать
                </button>
              </td>
              <td>
                <button
                  :disabled="layer.composition && getRestricts(layer.composition).landType !== 1 && layer.layer === '1'"
                  @click="rmLayer(layer)"
                >
                  Удалить
                </button>
              </td>
            </tr>

            <tr v-else>
              <td>{{ 
                      layer.layer 
                  }}
              </td>
              <td v-if="[1,21,22,23,4].includes(editedLayer.type)">
                <custom-p-input v-model="editedLayer.composition"/>
              </td>
              <td v-else>
                {{ layer.composition }}
              </td>
              <td v-if="[1,21,23].includes(editedLayer.type)">
                <custom-p-input
                  v-model="editedLayer.fullness"
                  type="number"
                  step="0.1"
                  min="0.0"
                  max="5.0"
                />
              </td>
              <td v-else>{{ layer.fullness }}</td>
              <td v-if="[1,21,22,23,4].includes(editedLayer.type)">
                <custom-p-input v-model="editedLayer.stock" type="number" />
              </td>
              <td v-else>{{ layer.stock }}</td>

              <!-- //anton
                <td>
                <custom-p-input
                  v-model="editedLayer.age_class"
                  :disabled="
                    (isDeadOrBurntForest && layer.layer === '2') ||
                      (isDeadSuhostoi && layer.layer === '1')
                  "
                  type="number"
                />
              </td>
              -->
              <td><button @click="saveEditLayer" :disabled="checkLayerSaveButton(editedLayer)">Сохранить</button></td>
              <td><button @click="cancelEditLayer">Отмена</button></td>
            </tr>
          </tbody>
        </table>

        <p-message severity="warn" v-if="!isTenSpecies(layer) && ([1,21,22,23,4].includes(getRestricts(layer.composition).landType))"
          >Суммарная доля пород не равна 10 {{layer.layer == 11 ? '(единичные деревья)': `(ярус ${layer.layer})`}}
          </p-message
        >

        <div class="layer-species flex-container" v-if='[1,2,21,22,23,4].includes(getRestricts(layer.composition).landType)'>
          <div>Список пород яруса:</div>

          <table class="tax-table species-table flex-item">
            <thead>
              <tr>
                <th>№</th>
                <th>Порода</th>
                <th>Сокращенное название</th>
                <th>Поколение</th>
                <th>Доля</th>
                <th>Возраст, лет</th>
                <th>Высота, м</th>
                <th>Диаметр, см</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(species, species_i) in layerSpeciesList(layer)">
                <template
                  v-if="
                    editedSpeciesNum.layer_i === layer_i &&
                      editedSpeciesNum.species_i === species_i
                  "
                >
                  <td>{{ species.species_num }}</td>
                  <td>
                    <custom-p-select
                      v-model="editedSpecies.species"
                      :options="info_species_ext"
                      dataKey="keyId"
                    />
                  </td>
                  <td>
                    <custom-p-select
                      v-model="editedSpecies.name_short"
                      :options="info_name_short"
                      :dataKey="null"
                      :optionLabel="null"
                    />
                  </td>
                    <td>
                      <custom-p-input v-model="editedSpecies.gen" type="number" />
                    </td>
                    <td>
                      <custom-p-input
                        v-model="editedSpecies.coeff"
                        :disabled="
                          isDeadOrBurntForest &&
                            layer.layer === '1' &&
                            !isDeadSuhostoi
                        "
                      />
                    </td>
                    <td>
                      <custom-p-input
                        v-model="editedSpecies.age"
                        :disabled="
                          isDeadOrBurntForest &&
                            layer.layer === '1' &&
                            !isDeadSuhostoi
                        "
                        type="number"
                      />
                    </td>
                    <td>
                      <custom-p-input
                        v-model="editedSpecies.h"
                        :disabled="
                          isDeadOrBurntForest &&
                            layer.layer === '1' &&
                            !isDeadSuhostoi
                        "
                        type="number"
                      />
                    </td>
                    <td>
                      <custom-p-input
                        v-model="editedSpecies.d"
                        :disabled="
                          isDeadOrBurntForest &&
                            layer.layer === '1' &&
                            !isDeadSuhostoi
                        "
                        type="number"
                      />
                    </td>
                  <td><button @click="saveEditSpecies">Сохранить</button></td>
                  <td><button @click="cancelEditSpecies">Отмена</button></td>
                  <td>
                    <div>
                      <button><i class="fa fa-caret-up"></i></button>
                      <button><i class="fa fa-caret-down"></i></button>
                    </div>
                  </td>
                </template>
                <template v-else>
                  <td>{{ species.species_num }}</td>
                  <td>{{ species.species_name }}</td>
                  <td>{{ species.name_short }}</td>
                  <td>{{ species.gen }}</td>
                  <td>{{ species.coeff === "0" ? "+" : species.coeff }}</td>
                  <td>{{ species.age }}</td>
                  <td>{{ species.h }}</td>
                  <td>{{ species.d }}</td>
                  <td>
                    <button
                      @click="startEditSpecies(layer_i, species_i, species)"
                      v-if="species.is_extra !== 't'"
                    >
                      Редактировать
                    </button>
                  </td>
                  <td><button @click="rmSpecies(species)">Удалить</button></td>
                  <td>
                    <div class="species-priority-btn-block">
                      <button @click="upSpeciesPriority(species)">
                        <i class="fa fa-caret-up"></i>
                      </button>
                      <button @click="downSpeciesPriority(species)">
                        <i class="fa fa-caret-down"></i>
                      </button>
                    </div>
                  </td>
                </template>
              </tr>

              <tr v-if="addModeSpeciesLayerNum === layer_i">
                <td></td>
                <td>
                  <custom-p-select
                    v-model="addedSpecies.species"
                    :options="info_species_ext"
                    :dataKey="null"
                  />
                </td>
                <td>
                  <custom-p-select
                    v-model="addedSpecies.name_short"
                    :options="info_name_short"
                    :dataKey="null"
                    :optionLabel="null"
                  />
                </td>
                <td>
                  <custom-p-input
                    v-model="addedSpecies.gen"
                    :disabled="addedSpecies.is_extra || ![1,21,22,23,4].includes(getRestricts(layer.composition).landType)"
                    type="number"
                  />
                </td>
                <td>
                  <custom-p-input
                    v-model="addedSpecies.coeff"
                    :disabled="
                        addedSpecies.is_extra || ![1,21,22,23,4].includes(getRestricts(layer.composition).landType)"
                  />
                </td>
                <td>
                  <custom-p-input
                    v-model="addedSpecies.age"
                    :disabled="
                        addedSpecies.is_extra || ![1,21,22,23,4].includes(getRestricts(layer.composition).landType)
                    "
                    type="number"
                  />
                </td>

                <td>
                  <custom-p-input
                    v-model="addedSpecies.h"
                    :disabled="
                      addedSpecies.is_extra || ![1,21,22,23,4].includes(getRestricts(layer.composition).landType)
                    "
                    type="number"
                  />
                </td>
                <td>
                  <custom-p-input
                    v-model="addedSpecies.d"
                    :disabled="
                      addedSpecies.is_extra || ![1,21,22,23,4].includes(getRestricts(layer.composition).landType)
                    "
                    type="number"
                  />
                </td>
                <td>
                  <button @click="saveAddSpecies(layer)" :disabled="!(addedSpecies.species && addedSpecies.name_short)">Сохранить</button>
                </td>
                <td><button @click="cancelAddSpecies">Отмена</button></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="common-btn-row" v-if='[1,2,21,22,23,4].includes(getRestricts(layer.composition).landType)'>
          <div>
            <button @click="startAddSpecies(layer_i)">Добавить породу</button>
          </div>
        </div>
      </div>
    </template>

    <template v-if="addModeLayer">         <!--добавление нового яруса-->
      <table class="table-common">
        <thead>
          <tr>
            <th>Ярус</th>
            <th v-if="[1,3,2].includes(addedLayer.type)">
              Состав
            </th>
            <th v-else>
              {{getTypeComposition(addedLayer.type)}} состав
            </th>
            <th>Полнота</th>
            <th>Запас сырорастущий, куб.м/га</th>
            <!-- <th>Запас сухостоя, куб.м/га</th> -->
            <!--<th>Класс возраста</th> -->
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ layerList.length + 1 }}</td>
            <td v-if="[1,21,22,23,4].includes(addedLayer.type)"><custom-p-input v-model="addedLayer.composition" /></td>
            <td v-else>{{ addedLayer.composition }}</td>
            <td v-if="[1,21,23].includes(addedLayer.type)">
              <custom-p-input
                v-model="addedLayer.fullness"
                type="number"
                step="0.1"
                min="0.0"
                max="5.0"
              />
            </td>
            <td v-else>{{ addedLayer.fullness }}</td>
            <td><custom-p-input v-model="addedLayer.stock" type="number" /></td>
            <!-- //anton
            <td>
              <custom-p-input
                v-model="addedLayer.age_class"
                :disabled="isDeadOrBurntForest && layerList.length + 1 === 2"
                type="number"
              />
            </td>
             -->
            <td><button :disabled="checkLayerSaveButton(addedLayer)" @click="saveAddLayer()">Сохранить</button></td>
            <td><button @click="cancelAddLayer">Отмена</button></td>
          </tr>
        </tbody>
      </table>
    </template>                     <!-- конец добавление нового яруса startAddLayer(checkEdDer.landTypeLast)-->
    <br><button @click="startAddLayer(1)" v-if="!checkEdDer.matchEd && checkEdDer.landTypeLast == 1 && !addModeLayer && (editedLayerNum == -1)">Добавить ярус</button>
    <template v-if="((!checkEdDer.matchEd && checkEdDer.landTypeLast == 1) || (!checkEdDer.matchEd && checkEdDer.landTypeLast !=1 && layerList.length == 1)) && !addModeLayer && (editedLayerNum == -1)">
      <button @click="startAddLayer(4)">
        Добавить ед.деревья
      </button>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import eventBus from '../../api/eventBus.js'
export default {
  name: "TaxDataEditLayers",

  data: () => ({
    testValue: null,
    testList: [
      { id: 1, name: "lala" },
      { id: 2, name: "nana" },
    ],

    valueLayers: [],

    addModeLayer: false,
    addedLayer: {
      type: null,
      composition: null,
      fullness: null,
      stock: null,
      // stock_dead: null,
      //age_class: null,
    },

    editedLayerNum: -1,
    editedLayer: {
      layer_id: null,
      composition: null,
      fullness: null,
      stock: null,
      // stock_dead: null,
      //age_class: null,
    },

    addModeSpeciesLayerNum: -1,

    addedSpecies: {
      species: null,
      is_extra: false,
      name_short: null,
      gen: null,
      coeff: null,
      age: null,
      h: null,
      d: null,
    },

    editedSpeciesNum: {
      layer_i: -1,
      species_i: -1,
    },
    editedSpecies: {
      id: null,
      species: null,
      name_short: null,
      gen: null,
      coeff: null,
      age: null,
      h: null,
      d: null,
    },

    dontChangeNameShort: false,
  }),
  computed: {
    checkEdDer() {
      if (this.layerList.length > 0) {
        const matchEd = this.layerList.map((item) => {return item.composition}).find(element => {
          if (element.includes('единичные деревья')) {
            return true;
          }
        }) != undefined
        const landTypeLast = this.getRestricts(this.layerList[this.layerList.length-1].composition).landType
        return { matchEd: matchEd, landTypeLast: landTypeLast }  
      } else {
        return { matchEd: false, landTypeLast: 1 } 
      }
    },
    info_species_ext() {
      const result = this.info_species.map((species) => {
        return {
          ...species,
          keyId: species.id + species.name,
        };
      });

      return result;

      // const filtered = result.filter((species) => species.id !== "809");
      // console.log("filtered: ", filtered);
      // return filtered;
    },

    layerList() {
      if (this.selectedTax.length === 1 && !this.selectedTax[0].layer_id) {
        return [];
      }

      const result = [];
      for (const item of this.selectedTax) {
        if (!result.find((row) => row.layer === item.layer)) {
          result.push(item);
        }
      }
      return result;
    },
    // speciesList() {
    // 	if (this.selectedTax.length === 1 && !this.selectedTax[0].tax_species_id) {
    // 		return [];
    // 	}

    // 	const result = [];
    // 	for (const item of this.selectedTax) {
    // 		result.push(item);
    // 	}
    // 	return result;
    // },

    addedSpecies_species() {
      return this.addedSpecies.species;
    },
    editedSpecies_species() {
      return this.editedSpecies.species;
    },

    addedSpecies_isExtra() {
      return this.addedSpecies.is_extra;
    },

    info_name_short() {
      return this.info_species_name_short.map((item) => item.name);
    },

    ...mapState("taxInfo", {
      selectedTax: (state) => state["selectedTax"],
      info_species_name_short: (state) => state["info_species_name_short"],
    }),

    ...mapState({
      info_species: (state) => state.catalogs["info_species"],
    }),
    ...mapGetters("taxInfo", [
      "layerList",
      "isDeadForest",
      "isBurntForest",
      "isDeadOrBurntForest",
      "layerSpeciesList",
      "isDeadSuhostoi",
      'getLandTypes'
    ]),
  },
  watch: {
    addedSpecies_species(val) {
      if (val) {
        this.getSpeciesNameShort(val);
      } else {
        this.$store.commit("taxInfo/setSpeciesNameShort", []);
      }

      this.addedSpecies.name_short = null;
    },
    editedSpecies_species(val) {
      if (this.dontChangeNameShort) {
        this.dontChangeNameShort = false;
        return;
      }

      if (val) {
        console.log("species changed");
        this.getSpeciesNameShort(val);
      } else {
        this.$store.commit("taxInfo/setSpeciesNameShort", []);
      }

      this.editedSpecies.name_short = null;
    },

    addedSpecies_isExtra(val) {
      this.addedSpecies.coeff = null;
      this.addedSpecies.age = null;
      this.addedSpecies.h = null;
      this.addedSpecies.d = null;
    },
  },
  methods: {
    checkSostav(composition) {
      let regLes = /((?<coef>[0-9]{1,2})(?<spec>[А-Я]{1,3}))/gi
      let regLesM = /^(([0-9]{1,2})([А-Я]{1,3})){1,7}$/gi
      var isValid = false
      if (composition) {
        if(composition.replaceAll('+', '0').match(regLesM)) {
          let coefs = []
          for (const match of composition.matchAll(regLes)) {
            coefs.push(parseInt(match.groups.coef))
          }
          isValid = (coefs.reduce((a, b) => a + b, 0) == 10)
        }
      }
      return isValid
    },
    checkLayerSaveButton(layer) {
      var disabled = true
      if (layer.type == 4) { //единичные деревья
        if (layer.composition && layer.stock > 0 && this.checkSostav(layer.composition)) {
          disabled = false
        }
      } else if (layer.type == 1 || layer.type == null) { //насаждение
        if (layer.composition && layer.stock > 0 && (layer.fullness >= 0.3 && layer.fullness <= 1) && this.checkSostav(layer.composition)) {
          disabled = false
        }
      } else if ([21,23].includes(layer.type)) { //редина и свежий сухостой
        if (layer.stock > 0 && (layer.fullness > 0 && layer.fullness <= 1) && this.checkSostav(layer.composition)) {
          disabled = false
        }
      } else if ([22].includes(layer.type)) { //несомкнувшиеся культуры
        if (this.checkSostav(layer.composition)) {
          disabled = false
        }
      }
      return disabled
    },
    getRestricts(composition) {

      const typesUnforest = this.getLandTypes.typesUnforest.map(e => e.text)
			const typesNonforest = this.getLandTypes.typesNonforest.map(e=> e.text)
      let type = typesUnforest.includes(composition?.replace(' свежий сухостой', '')) ? 2: typesNonforest.includes(composition) ? 3: 1
      const testRedin = composition ? composition.indexOf('РЕДИНА ЕСТЕСТВЕННАЯ') !== -1: false
      if (testRedin) {
        type = 21
      }
      const testNesomkn = composition ? composition.indexOf('КУЛЬТУРЫ НЕСОМКН.') !== -1: false
      if (testNesomkn) {
        type = 22
      }
      const testSuh = composition ? composition.indexOf('свежий сухостой') !== -1: false
      if (testSuh) {
        type = 23
      }
      const edDerTest = composition ? composition.indexOf('единичные деревья') !== -1: false
      if (edDerTest) {
        type = 4
      }
      return {landType: type, redin: testRedin, suh: testSuh, nesomkn: testNesomkn, edDer: edDerTest}

    },
    getTypeComposition(id) {
      const landTypes = {
        1: 'насаждения', //насаждение
        2: 'другие не покрытые лесом', //не покрытые лесом
        21: 'РЕДИНА ЕСТЕСТВЕННАЯ', //не покрытые лесом редины
        22: 'КУЛЬТУРЫ НЕСОМКН.', //не покрытые лесом культуры несомкнувшиеся
        23: 'НАС. ПОГИБШЕЕ свежий сухостой', //не покрытые лесом погибшие свежий сухостой
        24: 'НАС. ПОГИБШЕЕ', //не покрытые лесом погибшие свежий сухостой
        3: 'не лесные', //не лесные
        4: 'единичные деревья', //ед.деревья
      }
      return landTypes[id] ? landTypes[id]: ""
    },
    isTenSpecies(layer) {
      const speciesList = this.layerSpeciesList(layer);

      let coeffSum = 0;

      for (const species of speciesList) {
        const coeff = species.coeff === "+" ? 0 : +species.coeff;
        coeffSum += +coeff;
      }

      return coeffSum === 10;
    },

    numFromStr(str) {
      return [...str]
        .map((i) => {
          if (isFinite(i) == true || i == ".") {
            return i;
          } else {
            return " ";
          }
        })
        .join("")
        .split(" ")
        .filter((i) => i != "")
        .map((i) => Number(i));
    },

    isTen(str) {
      const nums = this.numFromStr(str);

      const sum = nums.reduce((s, current) => {
        return s + current;
      }, 0);

      return sum === 10;
    },

    /* LAYER */
    startAddLayer(type) {
      this.addModeLayer = true;
      this.addedLayer.type = type;
    },
    // startAddSingleTreesLayer() {

    // },

    cancelAddLayer() {
      this.addModeLayer = false;
      //this.addedLayer.type = null;
    },

    saveAddLayer(type) {
      //this.setTaxGeneralValue({field: 'stock_single_tree', value: "2000"})
      //this.saveTaxGeneral([{field: 'stock_single_tree', value: '2000'}]).then((res) => {
      if (this.addedLayer.type == 4) {
        eventBus.$emit('stock-single-set', this.addedLayer.stock)
      }
      //})
    
      const composition = this.addedLayer.composition
      if (!this.getRestricts(composition).redin) {
        if (!this.isTen(this.addedLayer.composition)) {
          this.$toast.add({
            severity: "warn",
            detail: "Состав не равен 10 единицам",
            life: 10000,
            position: "top-center",
          });
          return;
        }
      }
      
      if ([4,21,22,23].includes(this.addedLayer.type)) {
        this.addedLayer.composition = `${this.getTypeComposition(this.addedLayer.type)} ${this.addedLayer.composition}`;
      }

      this.addLayer(this.addedLayer).then((res) => {
        this.cancelAddLayer();
        this.updateTax();
        this.clearAddLayer();
      });
    },

    clearAddLayer() {
      this.addedLayer.type = null;
      this.addedLayer.composition = null;
      this.addedLayer.fullness = null;
      this.addedLayer.stock = null;
      this.addedLayer.stock_dead = null;
      //this.addedLayer.age_class = null;
    },

    startEditLayer(layer, layer_i) {
      this.editedLayerNum = layer_i;

      this.editedLayer.layer_id = layer.layer_id;
      this.editedLayer.type = this.getRestricts(layer.composition).landType
      if ([21,22,23,4].includes(this.editedLayer.type)) {
        this.editedLayer.composition = layer.composition.replaceAll(this.getTypeComposition(this.editedLayer.type)+" ", "")
      } else {
        this.editedLayer.composition = layer.composition;
      }
      this.editedLayer.fullness = layer.fullness;
      this.editedLayer.stock = layer.stock;
      // this.editedLayer.stock_dead = layer.stock_dead;
      //this.editedLayer.age_class = layer.age_class;
    },

    saveEditLayer() {
      // console.log(JSON.stringify(this.editedLayer, null, 2));
      /*if (!this.isTen(this.editedLayer.composition) && [1,21,22,23,4].includes(this.getRestricts(this.editedLayer.composition).landType)) {
        console.log(this.$toast);
        this.$toast.add({
          severity: "warn",
          detail: "Состав не равен 10 единицам",
          life: 10000,
          position: "top-center",
        });
        return;
      }*/
      if ([4,21,22,23].includes(this.editedLayer.type)) {
        this.editedLayer.composition = `${this.getTypeComposition(this.editedLayer.type)} ${this.editedLayer.composition}`;
      }
      if (this.editedLayer.type == 4) {
        eventBus.$emit('stock-single-set', this.editedLayer.stock)
      }
      console.log(this.isTen(this.editedLayer.composition));

      this.editLayer(this.editedLayer).then((res) => {
        this.cancelEditLayer();
        this.updateTax();
      });
    },

    cancelEditLayer() {
      this.editedLayerNum = -1;
    },

    rmLayer(layer) {
      const confirmation = confirm("Удалить ярус?");
      if (!confirmation) {
        return;
      }
      if(layer.layer == 11) {
        eventBus.$emit('stock-single-set', 0)
      }
      this.removeLayer(layer).then((res) => {
        this.updateTax();
      });
      console.log(this)
      

    },

    /* SPECIES */
    upSpeciesPriority(species) {
      // console.log(JSON.stringify(species, null, 2));

      this.upSpeciesNum(species)
        .then((res) => {
          this.updateTax();
        })
        .catch((err) => {
          if (err.message === "FIRST_SPECIES_ERROR") {
            this.$toast.add({
              severity: "warn",
              detail: "Порода уже является первой",
              life: 10000,
            });
          } else if (err.message === "ALREADY_PROCESSING") {
            this.$toast.add({
              severity: "warn",
              detail: "Идет обработка",
              life: 10000,
            });
          } else {
            throw err;
          }
        });
    },
    downSpeciesPriority(species) {
      this.downSpeciesNum(species)
        .then((res) => {
          this.updateTax();
        })
        .catch((err) => {
          if (err.message === "LAST_SPECIES_ERROR") {
            this.$toast.add({
              severity: "warn",
              detail: "Порода уже является последней",
              life: 10000,
            });
          } else if (err.message === "ALREADY_PROCESSING") {
            this.$toast.add({
              severity: "warn",
              detail: "Идет обработка",
              life: 10000,
            });
          } else {
            throw err;
          }
        });
    },

    startAddSpecies(layer_i) {
      this.addedSpecies.species = null;
      this.addedSpecies.gen = 1;
      this.addedSpecies.coeff = null;
      this.addedSpecies.age = null;
      this.addedSpecies.h = null;
      this.addedSpecies.d = null;

      this.addModeSpeciesLayerNum = layer_i;
    },

    saveAddSpecies(layer) {
      // console.log(layer);
      if (!this.addedSpecies.species) {
        console.log("no species");
        return;
      }

      const temp = {
        layer,
        species: this.addedSpecies,
      };

      this.addSpecies(temp).then((res) => {
        this.cancelAddSpecies();
        this.updateTax();
      });
    },

    cancelAddSpecies() {
      this.addModeSpeciesLayerNum = -1;
    },

    startEditSpecies(layer_i, species_i, species) {
      // console.log(species);
      this.dontChangeNameShort = true;

      this.editedSpecies.id = species.tax_species_id;

      const finded = this.info_species_ext.find((s) => {
        return s.keyId === species.species_id + species.species_name;
      });

      if (finded) {
        this.editedSpecies.species = { ...finded };
        this.getSpeciesNameShort(this.editedSpecies.species);
      }

      // this.editedSpecies.species = {
      // 	id: species.species_id,
      // 	name: species.species_name
      // };
      this.editedSpecies.name_short = species.name_short;
      this.editedSpecies.gen = species.gen;
      this.editedSpecies.coeff = species.coeff === "0" ? "+" : species.coeff;
      this.editedSpecies.age = species.age;
      this.editedSpecies.h = species.h;
      this.editedSpecies.d = species.d;

      this.editedSpeciesNum.layer_i = layer_i;
      this.editedSpeciesNum.species_i = species_i;

      console.log("name_short: ", this.editedSpecies.name_short);
    },

    saveEditSpecies() {
      this.editSpecies(this.editedSpecies).then((res) => {
        this.cancelEditSpecies();
        this.updateTax();
      });
    },

    cancelEditSpecies() {
      this.editedSpeciesNum.layer_i = -1;
      this.editedSpeciesNum.species_i = -1;
    },

    rmSpecies(species) {
      this.removeSpecies(species).then((res) => {
        this.cancelAddSpecies();
        this.updateTax();
      });
    },

    changeSpeciesIsMain(species, layer, event) {
      const checked = event.target.checked;
      // console.log(checked);

      const temp = {
        species,
        layer,
      };

      this.changeMain(temp).then((res) => {
        this.updateTax();
      });
    },

    ...mapActions("taxInfo", [
      "updateTax",
      "addLayer",
      "editLayer",
      "removeLayer",
      "addSpecies",
      "editSpecies",
      "removeSpecies",
      "changeMain",

      "getSpeciesNameShort",

      "upSpeciesNum",
      "downSpeciesNum",
      "saveTaxGeneral"
    ]),

    ...mapActions(["loadCatalogs"])
  },

  created() {
    const catalogs = ["info_species"];
    this.loadCatalogs(catalogs);
    eventBus.$on('add-layer', (e) => {
      this.startAddLayer(e)
    })
    eventBus.$on('stop-add-layer', (e) => {
      this.cancelAddLayer()
      this.clearAddLayer()
      this.cancelEditLayer()
    })
  },
  beforeDestroy() {
    eventBus.$off('add-layer')
    eventBus.$off('stop-add-layer')
  }
};
</script>

<style scoped src="@/style/table.css"></style>
<style scoped src="@/style/flex.css"></style>
<style scoped src="@/style/button.css"></style>

<style scoped>
.disabled-content {
  pointer-events: none;
  opacity: 0.4;
}
.layer-species {
  display: flex;
  margin-top: 20px;
  gap: 20px;
}

.layer-container {
  margin-bottom: 50px;
}

.species-table {
}

.species-table th {
  border-bottom: 2px solid black;
  font-weight: bold;
  padding: 6px 20px;
}
.species-table td {
  border-bottom: 1px solid black;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
}

.species-priority-btn-block {
  display: flex;
  flex-direction: column;
}
.species-priority-btn-block > button {
  width: 24px;
}
</style>
